module.exports = __webpack_public_path__ + "img/pulkruh.4f36ecfe.svg";